import { useIsSuspendedFacade } from './useIsSuspendedFacade';
import { usePaymentPlan } from '../queries/usePaymentPlan';

export const usePaymentPlanFacade = (isStripe: boolean, isTrialer = false, enabled = true) => {
  const { data: isSuspendedData, isLoading: isLoadingIsSuspended } = useIsSuspendedFacade();
  const isSuspended = !isLoadingIsSuspended && isSuspendedData;
  const paymentPlanQuery = usePaymentPlan(isStripe, isSuspended, isTrialer, enabled);

  return paymentPlanQuery;
};

export type UsePaymentPlanFacade = ReturnType<typeof usePaymentPlanFacade>;
